import { request } from '../axios/request';

import {
  FETCH_TRANSFERS_PENDING,
  FETCH_TRANSFERS_REJECTED,
  FETCH_TRANSFERS_FULFILLED,
} from '../constants/transfers';

const OMS = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/urls`);

const pending = () => ({
  type: FETCH_TRANSFERS_PENDING,
});

const rejected = (error) => ({
  type: FETCH_TRANSFERS_REJECTED,
  error,
});

const fulfilled = (response) => ({
  type: FETCH_TRANSFERS_FULFILLED,
  response,
});

export const fetchTransfers = (orderNumber) => (dispatch) => {
  dispatch(pending());

  const url = OMS.OMS.TRANSFERS.replace('{0}', orderNumber);
  request({ method: 'get', url })
    .then((response) => {
      dispatch(fulfilled(response.data));
    })
    .catch((error) => {
      dispatch(rejected(error));
    });
};



// WEBPACK FOOTER //
// ./src/actions/transfers.js